import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { AccessibleIcon } from "@/components/accessible-icon";
import { Button } from "@/components/button";
import { PlusIcon } from "@/components/icons.tsx";
import { UnlockModal } from "@/components/upgrade-modals/unlock-modal";
import { FeatureGuard } from "@/features/auth/permissions/feature-guard";
import { useUser } from "@/hooks/useUser";
import { isKickstarterAccount } from "@/utils/isKickstarterAccount";

import { useGetBrandsList } from "../hooks/useGetBrandsList";

export function Header() {
  const { data: userData } = useUser();
  const navigate = useNavigate();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const { data: brandsResponse } = useGetBrandsList({
    direction: "desc",
    itemsPerPage: 1,
    page: 1,
    search: "",
    sortBy: "createdAt",
  });

  const isKickstarter = isKickstarterAccount(
    userData?.user.accountType ?? null,
  );
  const brandsCount = brandsResponse?.metadata?.totalItems ?? 0;
  const shouldShowUpgradeModal = isKickstarter && brandsCount >= 1;

  const handleCreateBrand = () => {
    if (shouldShowUpgradeModal) {
      setShowUpgradeModal(true);

      return;
    }
    navigate({ to: "/brands/create" });
  };

  return (
    <>
      <div className="flex items-center justify-between gap-2xl rounded-t-xl bg-bg-primary px-2xl pb-2xl pt-xl border-b border-b-border-secondary">
        <span className="line-clamp-1 text-display-xs font-semibold text-text-primary">
          Brands
        </span>
        <FeatureGuard feature="create-brand-button">
          <Button onPress={handleCreateBrand}>
            <AccessibleIcon>
              <PlusIcon />
            </AccessibleIcon>
            New brand
          </Button>
        </FeatureGuard>
      </div>

      <UnlockModal
        isOpen={showUpgradeModal}
        onOpenChange={setShowUpgradeModal}
        onUpgrade={() => {
          setShowUpgradeModal(false);
          navigate({ to: "/pricing" });
        }}
      />
    </>
  );
}
